import React, { useState } from "react";
import styles from '../styles/bankCard.module.scss'
import { useAssetImage } from "@/platforms/utils";
import MaskDot from "./maskDot";
import Icon from "@/wmCompoments/Icon";
import { useCardList, useDecryptData, useDeleteCard } from "@/api/request";
import { CardType, Fingerprint, getWalletLocalConfig } from "@/utils/wallet";
import DeleteConfirm from "../dialog/deleteConfirm";
import Toast from "@/wmCompoments/toast";
import ErrorMessageDialog from "@/antComponent/errorMessageDialog";
import DesensitzeData from "../dialog/desensitzeData";
import { useCardNumberStorage } from "@/provides/cardNumberProvider";
import SpinLoading from "@/wmCompoments/spinLoading";

interface Props {
    data: any
}
const BankCard = (props: Props) => {
    const { data } = props
    const bgImage = useAssetImage('bankCardBg')
    const logoImage = useAssetImage('bankLogo')
  
    const conifg = getWalletLocalConfig(CardType.Bank);
    const [visible, setVisible] = useState(false)
    const { trigger } = useDeleteCard(conifg?.delApi)
    const { mutate } = useCardList(conifg?.api)
    const [eyeSwitch, setEyeSwitch] = useState(false)
    const [desensitzeVisible, setDesensitzeVisible] = useState(false)
    const { trigger: triggerDecrypt } = useDecryptData()
    const { setItem, data: cardData } = useCardNumberStorage()
    const [eyeloading, setEyeloading] = useState(false)

    const onClickDelete = () => {
        setVisible(true)
    }

    const handleDelete = async () => {
        try {
            await trigger({
                id: data?.id,
                /**暂不清楚该字段含义 */
                twoPassword: ''
            })
            await mutate()
        } catch (error: any) {
            ErrorMessageDialog(error?.message ?? JSON.stringify(error))
        }
    }

    const handleDecrypt = async () => {
        if (eyeSwitch) {
            setEyeSwitch(false)
            return
        }
        if (!window.isVerifyEencryption) {
            setDesensitzeVisible(true)
        } else {
            if (cardData?.[data?.id]) {
                setEyeSwitch(true)
            } else {
                try {
                    setEyeloading(true)
                    const decrypt = await triggerDecrypt({
                        code: '',
                        encryptedString: '',
                        fingerprint: data?.[Fingerprint.XsS2]
                    })
                    setItem(data?.id, decrypt.data)
                    setEyeSwitch(true)
                } catch (error: any) {
                    Toast.show(error?.message ?? JSON.stringify(error))
                } finally {
                    setEyeloading(false)
                }
            }
        }
    }


    return <div className={styles.item}>
        <div className={styles.bgImage}>
            <img src={bgImage} />
            <div className={styles.logo}>
                <img src={logoImage} />
            </div>
        </div>
        <div className={styles.warpper}>
            <div className={styles.top}>
                <img src={data?.icon} className={styles.icon} />
                <span>{data?.bankName}</span>
                <Icon name={'icon-general-delete'} className={styles.iconDelete} onClick={() => onClickDelete()} />
            </div>
            <div className={styles.maskAccount}>
                <MaskDot maskedString={eyeSwitch? cardData?.[data?.id] : data?.cardNumDesensitization} />
                {eyeloading ? <SpinLoading /> : <Icon name={'icon-user-eye-off'} className={styles.iconEye} onClick={() => {
                    handleDecrypt()
                }} />}
            </div>
        </div>
        <DeleteConfirm visible={visible} onClose={() => {
            setVisible(false)
        }}
            onSubmit={handleDelete}
        />

        <DesensitzeData visible={desensitzeVisible} onClose={() => {
            setDesensitzeVisible(false)
        }} fingerprint={data?.[Fingerprint.XsS10]} onSuccess={(v) => {
            setItem(data?.id, v)
            setEyeSwitch(true)
        }} />
    </div>
}

export default BankCard